// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"3":"templates","348":"chat"}[chunkId] + "." + {"3":"b492615f","348":"76b933de"}[chunkId] + ".css";
};